import React from 'react'
import { FormattedHTMLMessage, Menu, MenuDivider, AppSvg, newIcons, NavMenuItem, Loader } from '@web/walter-ui-kit'
import { useAuth } from '@web/walter-lib/auth'

import { lang } from '../lang'
import LocaleButton from '../buttons/LocaleButton'
import ProTradeButton from '../buttons/ProTradeButton'
import ThemeButton from '../buttons/ThemeButton'
import ReferralButton from '../buttons/ReferralButton'
import styles from './style.module.css'
import { SettingsTabs } from '~modals/SettingsModal/Menu/const'
import { useSettingsModal } from '~modals/SettingsModal/useSettingsModal'
import { setRedirectPathname } from '~utils/redirectPathname'

interface Props {
    isMobile: boolean
}

function QuickMenu({ isMobile }: Props) {
    const { isAuth, logout, isLogoutLoading } = useAuth()
    const { setTab: setSettingsTab } = useSettingsModal()

    let content

    if (isAuth) {
        if (isMobile) {
            content = (
                <>
                    <ProTradeButton />
                    <ReferralButton />
                </>
            )
        }

        content = (
            <>
                <NavMenuItem
                    dataPointer="settings_button"
                    icon={<AppSvg path="new-icons" svgName={newIcons.ic24Settings} size={24} />}
                    type="button"
                    onClick={() => setSettingsTab(isMobile ? SettingsTabs.menu : SettingsTabs.account)}
                >
                    <FormattedHTMLMessage {...lang.settings} />
                </NavMenuItem>
                {content}
                <MenuDivider />
                <NavMenuItem
                    dataPointer="log_out_button"
                    icon={
                        isLogoutLoading ? (
                            <Loader width={24} height={24} />
                        ) : (
                            <AppSvg path="new-icons" svgName={newIcons.ic24Logout} size={24} />
                        )
                    }
                    type="button"
                    onClick={e => {
                        e.preventDefault()
                        setRedirectPathname(window.location.pathname)
                        logout()
                    }}
                >
                    <FormattedHTMLMessage {...lang.logOut} />
                </NavMenuItem>
            </>
        )
    } else if (isMobile) {
        content = (
            <>
                <ProTradeButton />
                <ThemeButton />
                <LocaleButton />
            </>
        )
    }

    return (
        <div className={styles.menu}>
            <Menu>{content}</Menu>
        </div>
    )
}

export default QuickMenu
